import { ASSIGNMENT_ROUTES } from "@tt-app/constants/router/assignment";
import { COURSE_ROUTES } from "@tt-app/constants/router/course";
import { EXERCISES_ROUTES } from "@tt-app/constants/router/exercise";
import { LEARNING_HISTORY_ROUTES } from "@tt-app/constants/router/learningHistory";
import { USER_ROUTES } from "@tt-app/constants/router/user";
import { SKILLS_ROUTES } from "@tt-app/constants/router/skills";
import { TERRATALK_LIVE_ROUTES } from "@tt-app/constants/router/terratalkLive";
import { RELEASE_NOTES_ROUTES } from "@tt-app/constants/router/releaseNotes";

const ROUTES = {
  ASSIGNMENT: ASSIGNMENT_ROUTES,
  COURSE: COURSE_ROUTES,
  EXERCISE: EXERCISES_ROUTES,
  LEARNING_HISTORY: LEARNING_HISTORY_ROUTES,
  HOME: {
    NAME: "home",
    PATH: "/"
  },
  NOT_FOUND: {
    NAME: "not-found",
    PATH: "*"
  },
  SKILLS: SKILLS_ROUTES,
  TERRATALK_LIVE: TERRATALK_LIVE_ROUTES,
  USER: USER_ROUTES,
  RELEASE_NOTES: RELEASE_NOTES_ROUTES
};

export { ROUTES };
